module.exports = ["cyberattack","autom","robot","blockchain","ai","algorithm","cryptocurr","5g","gdpr","patent_box","smart_contract","intellectu_properti","patent_law","internet_govern","digit_economi","entrepreneuri_ecosystem","platform_economi","share_economi","wireless_sensor","3d_print","zero_rate","distribut_ledger","smart_citi","open_data","internet_polici","person_data","social_respons","gig_economi","augment_realiti","machin_learn","digit_transform","free_speech","smart_home","onlin_platform","hate_speech"]


//////////////////
// WEBPACK FOOTER
// ./src/assets/words_ssrn.json
// module id = NKmV
// module chunks = 1